<template>
  <div :class="
    typeChart == 'line' ? 'line' :
      typeChart == 'bar' ? 'bar' :
        typeChart == 'doughnut' ? 'doughnut' : 'chart'
  ">
    <canvas :id="idChartProp"></canvas>
  </div>
</template>

<script>
import {
  Chart,
  ArcElement,
  LineElement,
  BarElement,
  PointElement,
  BarController,
  BubbleController,
  DoughnutController,
  LineController,
  PieController,
  PolarAreaController,
  RadarController,
  ScatterController,
  CategoryScale,
  LinearScale,
  LogarithmicScale,
  RadialLinearScale,
  TimeScale,
  TimeSeriesScale,
  Decimation,
  Filler,
  Legend,
  Title,
  Tooltip
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import MethodService from '@/service/MethodService';

Chart.register(
  ArcElement,
  LineElement,
  BarElement,
  PointElement,
  BarController,
  BubbleController,
  DoughnutController,
  LineController,
  PieController,
  PolarAreaController,
  RadarController,
  ScatterController,
  CategoryScale,
  LinearScale,
  LogarithmicScale,
  RadialLinearScale,
  TimeScale,
  TimeSeriesScale,
  Decimation,
  Filler,
  Legend,
  Title,
  Tooltip
);
Chart.register(ChartDataLabels);

export default {
  name: 'PlanetChart',
  props: {
    chartdata: {
      type: Object,
      default: null
    },
    options: {
      type: Object,
      default: null
    },
    typeChart: {
      type: String,
      default: null
    },
    idChart: {
      type: String,
      default: 'planet-chart'
    }
  },
  data() {
    return {
      idChartProp: MethodService.generateId(),
      chartInstance: null
    }
  },
  watch: {
    idChart(newVal) {
      console.log('newVal', newVal);
    },
    chartdata: {
      deep: true,
      handler(newVal) {
        if (this.chartInstance && newVal) {
          this.chartInstance.data = newVal;
          this.chartInstance.update();
        }
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        this.createChart();
      }, 500);
    });
  },
  beforeDestroy() {
    if (this.chartInstance) {
      this.chartInstance.destroy();
      this.chartInstance = null;
    }
  },
  methods: {
    createChart() {
      const ctx = document.getElementById(this.idChartProp);
      if (!ctx) return;
      const existing = Chart.getChart(ctx);
      if (existing) {
        existing.destroy();
      }
      if (this.chartInstance) {
        this.chartInstance.destroy();
        this.chartInstance = null;
      }
      this.chartInstance = new Chart(ctx, {
        type: this.typeChart,
        data: this.chartdata,
        options: this.options
      });
    }
  }
}
</script>
<style scoped lang="scss">
.line {
  height: 40vh;
  width: 100%;
}
</style>
